/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { Component } from 'react';
import Media from 'react-media';
import {
    object, string, shape, arrayOf, number, func, bool,
} from 'prop-types';
import DesktopCYOProductItems from './DesktopCYOProductItems';
import MobileCYOProductItems from './MobileCYOProductItems';

class CYOProductItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expansionPanelOpen: 'panel1', // first expansion panel will keep open by default
            selectedItems: {},
            selectedItemsNames: [],
            selectedItemsPerCategory: {},
            selectedBand: '',
        };
    }

    componentDidUpdate(previousProps) {
        const { selectedItemId } = this.props;
        if (selectedItemId !== previousProps.selectedItemId) {
            this.setState({
                selectedItems: {},
                selectedItemsNames: [],
                selectedItemsPerCategory: {},
            });
        }
    }

    getOptionSelectList = (maxOptionItems, selectedItems, component, totalProductSelected) => {
        const optionSelectList = [];
        const productId = component?.legacyId;
        if (Object.keys(selectedItems).length === 0) {
            let title = '';
            for (let i = 0; i <= maxOptionItems; i += 1) {
                title = i;
                if (i === 0) {
                    title = 'Select Qty';
                }
                optionSelectList.push(<option key={`option_${i}`} value={i}>{title}</option>);
            }
        } else if (selectedItems?.[productId]) {
            const selectedItemOfProduct = parseInt(selectedItems[productId], 10);
            const remainingItems = maxOptionItems - totalProductSelected;
            const optionToDisplay = selectedItemOfProduct + remainingItems;
            let title = '';
            for (let i = 0; i <= optionToDisplay; i += 1) {
                title = i;
                if (selectedItemOfProduct === 0 && i === 0) {
                    title = 'Select Qty';
                } else if (selectedItemOfProduct !== 0 && i === 0) {
                    title = 'Remove';
                }
                optionSelectList.push(<option key={`option_${i}`} value={i}>{title}</option>);
            }
        } else {
            let title = '';
            const remainingItems = maxOptionItems - totalProductSelected;
            for (let i = 0; i <= remainingItems; i += 1) {
                title = i;
                if (i === 0) {
                    title = 'Select Qty';
                }
                optionSelectList.push(<option key={`option_${i}`} value={i}>{title}</option>);
            }
        }
        return optionSelectList;
    }

    toggleExpansionPanel = (panel) => (event, newExpanded) => {
        this.setState({
            expansionPanelOpen: newExpanded ? panel : false,
        });
    }

    getPercentageProgressBar = (totalProductSelected, maxComponents) => {
        const porcentageProgress = (totalProductSelected * 100) / parseInt(maxComponents, 10);
        return porcentageProgress;
    }

    getTotalProductSelected = (cyoData) => {
        if (cyoData?.cyoGroup) {
            const availableComponents = [];
            cyoData.cyoGroup.forEach((componentGroup) => {
                if (componentGroup.type !== 'cyoBands' && componentGroup.components) {
                    componentGroup.components.forEach((component) => {
                        availableComponents.push(component);
                    });
                }
            });
            const { selectedItems } = this.state;
            let totalProductSelected = 0;

            availableComponents.forEach((availableComponent) => {
                const prodId = availableComponent?.legacyId;
                if (selectedItems?.[prodId]) {
                    totalProductSelected += parseInt(selectedItems[prodId], 10);
                }
            });
            return totalProductSelected;
        }
        return 0;
    }

    getTotalCategoryCount = (cyoGroup) => {
        const availableComponents = [];
        const prodName = cyoGroup?.name;
        cyoGroup.components.forEach((component) => {
            availableComponents.push(component);
        });
        const { selectedItemsPerCategory } = this.state;
        let totalCategory = 0;
        availableComponents.forEach((availableComponent) => {
            const prodId = availableComponent?.legacyId;
            if (selectedItemsPerCategory?.[prodName]) {
                if (typeof selectedItemsPerCategory?.[prodName]?.[prodId] !== 'undefined') {
                    totalCategory += parseInt(selectedItemsPerCategory?.[prodName]?.[prodId], 10);
                }
            }
        });
        return totalCategory;
    }

    handleRemoveProduct = (itemToRemove, isMobile) => {
        const { cyoData } = this.props;
        const { selectedItemsNames, selectedItems, selectedItemsPerCategory } = this.state;
        const updatedSelectedItemsNames = selectedItemsNames.filter((item) => item?.productId !== itemToRemove);
        const isRemovableItemExist = Object.prototype.hasOwnProperty.call(selectedItems, itemToRemove);

        if (cyoData?.cyoGroup) {
            cyoData.cyoGroup.forEach((cyoGroup) => {
                const prodName = cyoGroup?.name;
                if (selectedItemsPerCategory?.[prodName] && typeof selectedItemsPerCategory?.[prodName] !== 'undefined') {
                    if (selectedItemsPerCategory?.[prodName]?.[itemToRemove]) {
                        selectedItemsPerCategory[prodName][itemToRemove] = 0;
                        if (cyoGroup.type === 'cyoBands') {
                            this.setState({ selectedBand: '' });
                        }
                    }
                }
            });
        }
        if (isRemovableItemExist) {
            selectedItems[itemToRemove] = 0;
        }
        if (!isMobile) {
            if (typeof document !== 'undefined') {
                document.getElementById(`select_${itemToRemove}`).value = '0';
            }
        }
        this.setState({
            selectedItemsNames: updatedSelectedItemsNames,
            selectedItems,
            selectedItemsPerCategory,
        });
    };

    updateCYOProdData = (cyoData) => {
        const { brandId } = this.props;
        if (cyoData?.cyoGroup) {
            const availableComponents = [];
            cyoData.cyoGroup.forEach((componentGroup) => {
                componentGroup.components.forEach((component) => {
                    availableComponents.push(component);
                });
            });
            const { selectedItems } = this.state;
            const selectedCYOProducts = [];

            if (availableComponents) {
                availableComponents.forEach((availableComponent) => {
                    const { legacyId, id } = availableComponent;
                    if (selectedItems[legacyId] && selectedItems[legacyId] !== '0') {
                        selectedCYOProducts.push({
                            brandCode: brandId,
                            productCode: id,
                            productId: legacyId,
                            quantity: selectedItems[legacyId],
                            componentType: 'CYO',
                        });
                    }
                });
            }
            return selectedCYOProducts;
        }
        return null;
    };

    handleSelectedCyoProduct = (component, maxQtyPerComponent, cyoGroup, isMobileDecrement, isMobileIncrement) => (event) => {
        const { selectedItems, selectedItemsNames, selectedItemsPerCategory } = this.state;
        const { cyoData } = this.props;
        const prodId = component?.legacyId;
        const prodName = component?.name;

        // regex will replace every alphabetic or numberic character before ":" with empty string ''
        // thus replacing http or https from image url
        const itemImagePath = component.image?.path?.replace(/(^\w+:|^)/, '');
        const itemImageName = component.image?.name;

        let totalProductSelected = this.getTotalCategoryCount(cyoGroup);
        // If the current input exist decrease the value.
        if (selectedItems[prodId]) {
            totalProductSelected -= selectedItems[prodId];
        }
        // Calculate the total with the new value is comming.
        totalProductSelected += parseInt(event.target.value, 10);
        // Review if the select number is out of the total allowed
        if (totalProductSelected > maxQtyPerComponent) { /* eslint-disable no-param-reassign */
            // Set the current previous number if the user try increase it
            if (parseInt(event.target.value, 10) > parseInt(selectedItems?.[prodId], 10)) {
                event.target.value = parseInt(selectedItems?.[prodId], 10);
            } else {
                // Set 0 value is the total allow was set
                event.target.value = 0;
            }
        }

        // Setting initial state to count selected number of CYO products for mobile
        let totalProductSelectedMobile = 0;
        if (isMobileIncrement || isMobileDecrement) {
            totalProductSelectedMobile = this.getTotalProductSelected(cyoData);
            if (typeof selectedItems[prodId] === 'undefined') {
                selectedItems[prodId] = 0;
                this.setState({ selectedItems });
            }
        }

        // Handling mobile increment and decrement button for selecting number of CYO products
        if (isMobileIncrement) {
            if (totalProductSelectedMobile !== maxQtyPerComponent) {
                selectedItems[prodId] += 1;
            }
        } else if (isMobileDecrement) {
            if (selectedItems[prodId] > 0) {
                selectedItems[prodId] -= 1;
            }
        } else {
            selectedItems[prodId] = event.target.value;
        }

        // Add or update the new value in the selected product.
        let duplicateProdName = false;
        const SelectedItemsNames = selectedItemsNames;
        const SelectedItemsPerCategory = selectedItemsPerCategory;
        SelectedItemsNames.forEach((items) => {
            if (items?.name === prodName) {
                duplicateProdName = true;
                totalProductSelected -= selectedItems?.[prodId];
                items.value = event.target.value || selectedItems[prodId];
            }
        });

        if ((isMobileIncrement || isMobileDecrement) && !duplicateProdName) {
            SelectedItemsNames.push({
                productId: prodId,
                name: prodName,
                value: selectedItems[prodId],
                img: `${itemImagePath}${itemImageName}c.jpg`,
                component,
                cyoGroup,
                maxQtyPerComponent,
                selectedItems,
            });
        }

        if (parseInt(event.target.value, 10) !== 0 && !Number.isNaN(parseInt(event.target.value, 10)) && !duplicateProdName) {
            SelectedItemsNames.push({
                productId: prodId,
                name: prodName,
                value: event.target.value,
                img: `${itemImagePath}${itemImageName}c.jpg`,
                component,
                cyoGroup,
                maxQtyPerComponent,
                selectedItems,
            });
        }
        SelectedItemsPerCategory[cyoGroup.name] = {
            ...SelectedItemsPerCategory?.[cyoGroup.name],
            [prodId]: (isMobileIncrement || isMobileDecrement) ? selectedItems[prodId] : event.target.value,
        };
        const filteredSelectedNames = SelectedItemsNames.filter((item) => item?.value > '0');
        this.setState({
            selectedItems,
            selectedItemsNames: filteredSelectedNames,
            selectedItemsPerCategory: SelectedItemsPerCategory,
        });
    }

    onRadioButtonChange = (component, maxQtyPerComponent, cyoGroup) => (e) => {
        const { cyoData } = this.props;
        const {
            selectedItemsPerCategory, selectedItems, selectedBand,
        } = this.state;
        const allBandData = cyoData.cyoGroup?.find((group) => group.type === 'cyoBands');

        // Get new and old band data
        const oldSelectedBand = allBandData.components.find((componentData) => componentData.legacyId === selectedBand);
        const newSelectedBand = allBandData.components.find((componentData) => componentData.legacyId === e.target.value);
        let { selectedItemsNames } = this.state;

        // check if band already exisits in state values and remove it
        if (selectedItemsPerCategory.Band && selectedItems && selectedItemsNames && oldSelectedBand) {
            if (Object.keys(selectedItems).includes(oldSelectedBand.legacyId)
                || selectedItemsNames.find((item) => item.name === oldSelectedBand.name)
                || Object.keys(selectedItemsPerCategory.Band)?.includes(oldSelectedBand.legacyId)) {
                delete selectedItems[oldSelectedBand.legacyId];
                selectedItemsNames = selectedItemsNames.filter((item) => item.name !== oldSelectedBand.name);
                delete selectedItemsPerCategory.Band;
            }
        }

        // update new band data to variables
        selectedItems[newSelectedBand.legacyId] = '1';
        selectedItemsNames.push({
            name: newSelectedBand.name,
            productId: newSelectedBand.legacyId,
            value: '1',
            component,
            maxQtyPerComponent,
            cyoGroup,
            selectedItems,
        });
        selectedItemsPerCategory.Band = {
            [newSelectedBand.legacyId]: '1',
        };

        // update state
        this.setState({
            selectedItems,
            selectedItemsNames,
            selectedItemsPerCategory,
            selectedBand: newSelectedBand.legacyId,
        });
    }

    isBandItemSelected = () => {
        const { cyoData } = this.props;
        const { selectedBand } = this.state;
        if (!cyoData?.cyoGroup.some((group) => group.type === 'cyoBands')) {
            return true;
        }
        if (selectedBand !== '') {
            return true;
        }
        return false;
    }

    resetSelectedProducts = () => {
        this.setState({
            selectedItems: {},
            selectedItemsNames: [],
            selectedItemsPerCategory: {},
            selectedBand: '',
        });
    }

    render() {
        const {
            cyoData,
            selectedItemId,
            brandId,
            product,
            handleMiniCartModalClick,
            cartError,
            hasWine,
            handleMobileAgeVerification,
        } = this.props;
        if (!cyoData?.cyoGroup?.length) return null;

        const {
            expansionPanelOpen, selectedItemsNames, selectedItems, selectedBand, selectedItemsPerCategory,
        } = this.state;
        const totalProductSelected = this.getTotalProductSelected(cyoData);
        let maxSelectableForSku = 0;
        if (!cyoData.maxQuantity) {
            cyoData.cyoGroup.forEach((group) => {
                maxSelectableForSku += group.numberofUnitsRequiredForComponent;
            });
        } else {
            maxSelectableForSku = cyoData.maxQuantity;
        }
        let progressBarData = 0;
        let cyoSelectedComponents;
        if (totalProductSelected) {
            progressBarData = this.getPercentageProgressBar(totalProductSelected, maxSelectableForSku);
            cyoSelectedComponents = this.updateCYOProdData(cyoData);
        }

        return (
            <Media queries={{
                mobile: '(min-width: 320px) and (max-width: 767px)',
                desktop: '(min-width: 768px)',
            }}
            >
                {(matches) => (
                    matches.mobile
                        ? (
                            <MobileCYOProductItems
                                progressBarData={progressBarData}
                                totalProductSelected={totalProductSelected}
                                maxSelectableForSku={maxSelectableForSku}
                                cyoData={cyoData}
                                selectedBand={selectedBand}
                                onRadioButtonChange={this.onRadioButtonChange}
                                handleSelectedCyoProduct={this.handleSelectedCyoProduct}
                                getOptionSelectList={this.getOptionSelectList}
                                selectedItems={selectedItems}
                                getTotalProductSelected={this.getTotalProductSelected}
                                getTotalCategoryCount={this.getTotalCategoryCount}
                                cartError={cartError}
                                selectedItemsNames={selectedItemsNames}
                                selectedItemsPerCategory={selectedItemsPerCategory}
                                cyoSelectedComponents={cyoSelectedComponents}
                                handleRemoveProduct={this.handleRemoveProduct}
                                handleMiniCartModalClick={handleMiniCartModalClick}
                                selectedItemId={selectedItemId}
                                brandId={brandId}
                                product={product}
                                isBandItemSelected={this.isBandItemSelected}
                                hasWine={hasWine}
                                handleMobileAgeVerification={handleMobileAgeVerification}
                                resetSelectedProducts={this.resetSelectedProducts}
                            />
                        )
                        : (
                            <DesktopCYOProductItems
                                expansionPanelOpen={expansionPanelOpen}
                                cyoSelectedComponents={cyoSelectedComponents}
                                progressBarData={progressBarData}
                                cyoData={cyoData}
                                toggleExpansionPanel={this.toggleExpansionPanel}
                                getTotalCategoryCount={this.getTotalCategoryCount}
                                selectedBand={selectedBand}
                                onRadioButtonChange={this.onRadioButtonChange}
                                handleSelectedCyoProduct={this.handleSelectedCyoProduct}
                                getOptionSelectList={this.getOptionSelectList}
                                selectedItems={selectedItems}
                                getTotalProductSelected={this.getTotalProductSelected}
                                cartError={cartError}
                                totalProductSelected={totalProductSelected}
                                maxSelectableForSku={maxSelectableForSku}
                                selectedItemsNames={selectedItemsNames}
                                handleRemoveProduct={this.handleRemoveProduct}
                                handleMiniCartModalClick={handleMiniCartModalClick}
                                selectedItemId={selectedItemId}
                                brandId={brandId}
                                product={product}
                                isBandItemSelected={this.isBandItemSelected}
                                hasWine={hasWine}
                                handleMobileAgeVerification={handleMobileAgeVerification}
                            />
                        ))}
            </Media>
        );
    }
}

CYOProductItems.propTypes = {
    selectedItemId: string,
    brandId: string.isRequired,
    handleMiniCartModalClick: func.isRequired,
    cyoData: shape({
        maxQuantity: number.isRequired,
        cyoGroup: arrayOf(
            shape({
                name: string.isRequired,
                components: arrayOf(
                    shape({
                        id: string.isRequired,
                        legacyId: string.isRequired,
                        name: string.isRequired,
                        image: shape({
                            name: string.isRequired,
                            path: string.isRequired,
                        }),
                    }),
                ).isRequired,
            }),
        ).isRequired,
    }).isRequired,
    product: object.isRequired,
    hasWine: bool,
    cartError: string.isRequired,
    handleMobileAgeVerification: func,
};

CYOProductItems.defaultProps = {
    selectedItemId: null,
    hasWine: false,
    handleMobileAgeVerification: () => {},
};

export default CYOProductItems;
